import { useEffect, useState } from "react";
import useShouldShowPrompt from "./useShouldShowPrompt";

const iosInstallPromptedAt = "iosInstallPromptedAt";

const useIosInstallPrompt = (): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt] =
    useShouldShowPrompt(iosInstallPromptedAt);
  const [isIos, setIsIos] = useState(false);

  const isIOS = () => {
    const iosNavigator = navigator as Navigator & { standalone?: boolean };
    if (iosNavigator.standalone) {
      //user has already installed the app
      return false;
    }
    const ua = window.navigator.userAgent;
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i);
    const result = isIPad || isIPhone;
    setIsIos(result);
  };
  useEffect(() => {
    isIOS();
  }, []);

  return [isIos && userShouldBePromptedToInstall, handleUserSeeingInstallPrompt];
};
export default useIosInstallPrompt;
